import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col, Table, Card, Alert } from 'react-bootstrap';
import Moment from 'moment';
import CustomSpinner from '../../components/CustomSpinner';
import { getBusinessRedemptionsRequest } from '../../actions/index';

class BusinessRedemptions extends Component {
  static propTypes = {
    getRedemptions: PropTypes.func.isRequired,
    loadingRedemptions: PropTypes.bool,
    redemptions: PropTypes.shape({
      byReward: PropTypes.array,
      list: PropTypes.array,
      total: PropTypes.number,
    }),
  };

  componentDidMount() {
    this.props.getRedemptions();
  }

  render() {
    const { redemptions, loadingRedemptions } = this.props;

    if (loadingRedemptions) return <CustomSpinner />;

    return (
      <Container className="pt-5">
        <Row>
          <Col xs={12}>
            <h1 className="h1-list">Redemptions</h1>
          </Col>

          {redemptions && (
            <>
              <Col xs={12} md={4} className="mt-4">
                <Card className="text-center">
                  <Card.Body>
                    <Card.Title className="display-4">{redemptions.total}</Card.Title>
                    <Card.Text className="text-muted">Total Redemptions</Card.Text>
                  </Card.Body>
                </Card>
              </Col>

              {redemptions.byReward && redemptions.byReward.length > 0 && (
                <Col xs={12} md={8} className="mt-4">
                  <h5>By Reward</h5>
                  <Table responsive bordered size="sm">
                    <thead>
                      <tr>
                        <th>Reward ID</th>
                        <th>Redemptions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {redemptions.byReward.map(item => (
                        <tr key={item.rewardId}>
                          <td>
                            <small>{item.rewardId}</small>
                          </td>
                          <td>{item.count}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              )}

              <Col xs={12} className="mt-4">
                <h5>Recent Redemptions</h5>
                {redemptions.list && redemptions.list.length === 0 ? (
                  <Alert variant="info">No redemptions yet.</Alert>
                ) : (
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Reward ID</th>
                        <th>Card Brand</th>
                        <th>Card Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(redemptions.list || []).map(item => (
                        <tr key={item.id}>
                          <td>{item.redeemedAt ? Moment(item.redeemedAt).format('LLL') : '—'}</td>
                          <td>
                            <small>{item.rewardId || '—'}</small>
                          </td>
                          <td>{item.cardBrand || '—'}</td>
                          <td>{item.cardName || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Col>
            </>
          )}

          {!loadingRedemptions && !redemptions && (
            <Col xs={12} className="mt-4">
              <Alert variant="warning">Unable to load redemptions. Please refresh.</Alert>
            </Col>
          )}
        </Row>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    redemptions: state.business.redemptions,
    loadingRedemptions: state.business.loadingRedemptions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRedemptions: () => dispatch(getBusinessRedemptionsRequest()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BusinessRedemptions);
